module.exports = "<jhi-jumbotron>\n    <h1>Conditions générales d'utilisation</h1>\n</jhi-jumbotron>\n\n<div class=\"container\">\n    <jhi-cgu [cguTypeEnum]=\"cguTypeEnum\"></jhi-cgu>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/footer/condition-generale/condition-generale.component.html
// module id = 809
// module chunks = 0